"use client";

import React from "react";
import { Step } from "nextstepjs";

interface TourCustomCardProps {
  step: Step;
  currentStep: number;
  totalSteps: number;
  nextStep: () => void;
  prevStep: () => void;
  skipTour?: () => void | null;
  arrow: React.ReactNode;
}

const TourCustomCard = ({
  step,
  currentStep,
  totalSteps,
  nextStep,
  prevStep,
  skipTour,
  arrow,
}: TourCustomCardProps) => {
  return (
    <div className="bg-white dark:bg-card text-card dark:text-card-foreground rounded-lg shadow-lg p-6 max-w-md">
      <div className="flex items-center gap-3 mb-4">
        {step.icon && <div className="text-2xl">{step.icon}</div>}
        <h3 className="text-xl font-bold">{step.title}</h3>
      </div>

      <div className="mb-6">{step.content}</div>

      <div className="text-primary">
        {arrow}
      </div>
      <div className="flex flex-col items-center gap-2">
        <div className="text-sm">
          Step {currentStep + 1} of {totalSteps}
        </div>

        <div className="flex justify-between items-center">
          <div className="flex gap-2">
            {currentStep > 0 && (
              <button
                onClick={prevStep}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-card-foreground/30 rounded"
              >
                Previous
              </button>
            )}

            <button
              onClick={nextStep}
              className="px-4 py-2 bg-primary dark:bg-primary text-card-foreground/30 rounded"
            >
              {currentStep === totalSteps - 1 ? "Finish" : "Next"}
            </button>
          </div>
          {step.showSkip && (
            <button
              onClick={skipTour}
              className="px-4 py-2 text-card-foreground/50 dark:text-gray-400"
            >
              Skip
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TourCustomCard;
